import { InteractiveMap } from "./InteractiveMap";
import { COVERAGE_SPOTLIGHT } from "../../data/content";
import { Reveal } from "./Reveal";

export const Coverage = () => (
  <section className="section section--dark" id="coverage" aria-labelledby="coverage-heading">
    <div className="container">
      <div className="section-header" style={{ textAlign: "center" }}>
        <div className="section-label">Geographical Coverage</div>
        <h2 className="section-heading" id="coverage-heading">
          73 Countries. 5 Regions. <em>One Global Practice.</em>
        </h2>
        <p className="section-sub" style={{ marginInline: "auto" }}>
          From community-level assessments to multi-country portfolio evaluations, evidence work
          delivered across diverse contexts and continents.
        </p>
      </div>

      <InteractiveMap />

      <div className="spotlight">
        <h3 className="spotlight-title">Coverage <em>Spotlight</em></h3>
        <div className="spotlight-grid">
          {COVERAGE_SPOTLIGHT.map((r, i) => (
            <Reveal className="spotlight-card" key={r.region} delay={i * 60} data-testid={`spotlight-${i}`}>
              <div className="spotlight-region">
                <span className="map-dot" style={{ background: r.color }} aria-hidden="true" />
                {r.region}
                <span className="spotlight-count">{r.countries.length}</span>
              </div>
              <div className="spotlight-chips">
                {r.countries.map((c) => (
                  <span className="spotlight-chip" key={c}>{c}</span>
                ))}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
